import { useTranslation } from "react-i18next";
import { Field } from "../../../../../components/shared/Form";
import Checkbox from "../../../../../components/shared/inputs/Checkbox";

function Settings() {
    const { t } = useTranslation();

    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <span className="tw-text-sm tw-font-medium tw-text-foreground">{t("qualifications")}</span>
            <div className="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
                <Field name="skills" valuePropName="checked">
                    <Checkbox>{t("skills")}</Checkbox>
                </Field>
                <Field name="licenses" valuePropName="checked">
                    <Checkbox>{t("licenses")}</Checkbox>
                </Field>
                <Field name="certifications" valuePropName="checked">
                    <Checkbox>{t("certifications")}</Checkbox>
                </Field>
            </div>
        </div>
    );
}

export default Settings;
